import _ from "lodash";

import {TREE_NODE_KEY_PREFIX} from "../../components/tree-filter/utils";

export const getContentConstraintFilter = filter => {
  const res = _.cloneDeep(filter);
  if (res) {
    Object.keys(res).forEach(id => {
      res[id].values = (res[id].values && res[id].values.length)
        ? res[id].values.filter(val => !(val && val.startsWith(TREE_NODE_KEY_PREFIX)))
        : res[id].values;
    });
  }
  return res;
}
